var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 124,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.828 103.927-1.083-4.272a55.48 55.48 0 0 0-5.886-2.112l-.136 1.986-.555-2.188C1.688 96.632 0 96.321 0 96.321s2.279 8.667 7.06 15.294l5.57.978-4.327.624a22.334 22.334 0 0 0 1.935 2.051c6.955 6.456 14.701 9.418 17.302 6.616 2.6-2.802-.929-10.307-7.884-16.761-2.156-2.002-4.864-3.608-7.575-4.872l-.253 3.676Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.13 99.287 1.282-4.218a55.473 55.473 0 0 0-3.947-4.85l-1.144 1.63.656-2.16c-1.757-1.889-3.04-3.028-3.04-3.028s-2.53 8.598-1.862 16.742l4.263 3.717-4.028-1.703c.14.931.34 1.852.597 2.757 2.616 9.121 7.717 15.661 11.391 14.606 3.675-1.054 4.533-9.302 1.916-18.423-.811-2.828-2.3-5.603-3.967-8.086l-2.117 3.016Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.829 29.226h-.676V10.714A10.715 10.715 0 0 0 74.44 0h-39.22a10.715 10.715 0 0 0-10.715 10.714v101.558a10.715 10.715 0 0 0 10.714 10.714h39.22a10.711 10.711 0 0 0 10.715-10.714v-69.87h.676V29.227Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.871 2.787h-5.12a3.801 3.801 0 0 1-3.52 5.237H43.764a3.801 3.801 0 0 1-3.52-5.237h-4.782a8.002 8.002 0 0 0-8 8.002v101.41a8.003 8.003 0 0 0 8 8.001h39.41a8.003 8.003 0 0 0 8.001-8.001V10.789a8.001 8.001 0 0 0-8.001-8.002Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.144 43.182a4.036 4.036 0 0 1 2.02-3.496 4.038 4.038 0 1 0 0 6.992 4.034 4.034 0 0 1-2.02-3.496Z",
    fill: "#CCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.22 43.182a4.035 4.035 0 0 1 2.02-3.496 4.038 4.038 0 1 0 0 6.992 4.034 4.034 0 0 1-2.02-3.496Z",
    fill: "#CCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.18 47.22a4.038 4.038 0 1 0 0-8.074 4.038 4.038 0 0 0 0 8.075Z",
    fill: "#1A33B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.18 47.22a4.038 4.038 0 1 0 0-8.074 4.038 4.038 0 0 0 0 8.075Z",
    fill: "#000",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.928 55.794H43.397a.846.846 0 0 1-.845-.845V31.417a.846.846 0 0 1 .845-.845h23.531a.846.846 0 0 1 .845.845V54.95a.846.846 0 0 1-.845.845ZM43.397 30.91a.507.507 0 0 0-.507.506V54.95a.507.507 0 0 0 .507.507h23.531a.507.507 0 0 0 .507-.507V31.417a.507.507 0 0 0-.507-.507H43.397ZM72.183 73.832h-36.09v.338h36.09v-.338Z",
    fill: "#CCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.232 71.722a1.14 1.14 0 1 0 0-2.28 1.14 1.14 0 0 0 0 2.28Z",
    fill: "#1A33B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.232 71.722a1.14 1.14 0 1 0 0-2.28 1.14 1.14 0 0 0 0 2.28Z",
    fill: "#000",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.183 85.228h-36.09v.339h36.09v-.338Z",
    fill: "#CCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.232 83.118a1.14 1.14 0 1 0 0-2.28 1.14 1.14 0 0 0 0 2.28Z",
    fill: "#1A33B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.232 83.118a1.14 1.14 0 1 0 0-2.28 1.14 1.14 0 0 0 0 2.28Z",
    fill: "#000",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.522 98.206H60.116a.744.744 0 0 1-.743-.743v-3.997a.744.744 0 0 1 .743-.743h11.406a.744.744 0 0 1 .743.743v3.997a.745.745 0 0 1-.743.743Z",
    fill: "#1A33B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.522 98.206H60.116a.744.744 0 0 1-.743-.743v-3.997a.744.744 0 0 1 .743-.743h11.406a.744.744 0 0 1 .743.743v3.997a.745.745 0 0 1-.743.743Z",
    fill: "#000",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.95 71.722a1.14 1.14 0 1 0 0-2.28 1.14 1.14 0 0 0 0 2.28Z",
    fill: "#1A33B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.95 71.722a1.14 1.14 0 1 0 0-2.28 1.14 1.14 0 0 0 0 2.28Z",
    fill: "#000",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.667 71.722a1.14 1.14 0 1 0 0-2.28 1.14 1.14 0 0 0 0 2.28Z",
    fill: "#1A33B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.667 71.722a1.14 1.14 0 1 0 0-2.28 1.14 1.14 0 0 0 0 2.28Z",
    fill: "#000",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.95 83.118a1.14 1.14 0 1 0 0-2.28 1.14 1.14 0 0 0 0 2.28Z",
    fill: "#1A33B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.95 83.118a1.14 1.14 0 1 0 0-2.28 1.14 1.14 0 0 0 0 2.28Z",
    fill: "#000",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.667 83.118a1.14 1.14 0 1 0 0-2.28 1.14 1.14 0 0 0 0 2.28Z",
    fill: "#1A33B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.667 83.118a1.14 1.14 0 1 0 0-2.28 1.14 1.14 0 0 0 0 2.28Z",
    fill: "#000",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.541 123.368H3.977c-.254 0-.46-.09-.46-.201 0-.111.206-.201.46-.201H122.54c.253 0 .459.09.459.201 0 .111-.206.201-.459.201Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.248 80.827c.08.037.158.08.233.13l7.406-3.162.264-1.95 2.96-.019-.175 4.475-9.776 2.585c-.02.068-.045.135-.074.2a1.69 1.69 0 1 1-.838-2.26ZM105.187 121.377h-2.024l-.963-7.809 2.988.001-.001 7.808Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.717 120.799h3.904v2.458h-6.363a2.458 2.458 0 0 1 2.459-2.458Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.061 120.805-2.015.199-1.724-7.677 2.973-.293.766 7.771Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.55 120.57 3.886-.383.241 2.446-6.332.624a2.449 2.449 0 0 1 .546-1.8 2.46 2.46 0 0 1 1.659-.887Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.751 67.562a4.056 4.056 0 1 0 0-8.112 4.056 4.056 0 0 0 0 8.112Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.71 119.798a.741.741 0 0 1-.729-.611c-1.048-5.817-4.473-24.837-4.555-25.364a.235.235 0 0 1-.002-.036v-1.418c0-.052.016-.102.046-.144l.452-.634a.244.244 0 0 1 .19-.103c2.579-.121 11.028-.476 11.436.034.41.513.265 2.066.232 2.372l.001.031 3.796 24.274a.742.742 0 0 1-.614.848l-2.37.391a.747.747 0 0 1-.83-.511c-.733-2.343-3.192-10.225-4.044-13.274a.082.082 0 0 0-.162.023c.042 2.907.145 10.324.181 12.886l.004.276a.75.75 0 0 1-.676.749l-2.286.208a.82.82 0 0 1-.07.003Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.177 69.157c-.708.42-1.132 1.194-1.375 1.98a18.784 18.784 0 0 0-.806 4.485l-.257 4.558-3.18 12.083c2.756 2.332 4.346 1.802 8.056-.106 3.709-1.907 4.133.636 4.133.636l.742-10.28 1.06-11.235a4.971 4.971 0 0 0-.803-.772 8.194 8.194 0 0 0-7.008-1.485l-.562.136Z",
    fill: "#1A33B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.177 69.157c-.708.42-1.132 1.194-1.375 1.98a18.784 18.784 0 0 0-.806 4.485l-.257 4.558-3.18 12.083c2.756 2.332 4.346 1.802 8.056-.106 3.709-1.907 4.133.636 4.133.636l.742-10.28 1.06-11.235a4.971 4.971 0 0 0-.803-.772 8.194 8.194 0 0 0-7.008-1.485l-.562.136Z",
    fill: "#000",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.144 83.267c.085.032.168.07.248.116l7.323-3.665.122-1.986 3.021-.209.162 4.527-9.787 3.237a1.738 1.738 0 0 1-1.459 1.324 1.732 1.732 0 1 1 .37-3.344Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.497 71.33c1.802.636 2.119 7.526 2.119 7.526-2.12-1.166-4.663.742-4.663.742s-.53-1.802-1.166-4.134a4.054 4.054 0 0 1 .848-3.816s1.06-.954 2.862-.318Z",
    fill: "#1A33B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.497 71.33c1.802.636 2.119 7.526 2.119 7.526-2.12-1.166-4.663.742-4.663.742s-.53-1.802-1.166-4.134a4.054 4.054 0 0 1 .848-3.816s1.06-.954 2.862-.318Z",
    fill: "#000",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.388 64.579c-.506-.405-1.195.33-1.195.33l-.404-3.638s-2.527.302-4.144-.101c-1.617-.404-1.87 1.465-1.87 1.465a12.99 12.99 0 0 1-.05-2.274c.101-.91 1.414-1.819 3.739-2.425 2.325-.607 3.537 2.021 3.537 2.021 1.618.809.892 5.026.387 4.622Z",
    fill: "#2F2E41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h123v123.368H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUp);
export default __webpack_public_path__ + "static/media/sign_up.38442a0a43da29f3a0ac72d150e76b96.svg";
export { ForwardRef as ReactComponent };